import React from "react";
import { useTranslation, useI18next } from "gatsby-plugin-react-i18next";
import { Slider } from "components/Design/Slider";
import { CardContactUsContent } from "components/Design/Card";
import { SectionTitle } from "components/SectionTitle";

const ContactUsContents = ({ hotels }) => {
  const { language } = useI18next();
  const { t } = useTranslation(["support", "homepage"]);

  const cards = hotels.map((item) => (
    <CardContactUsContent
      key={item.id}
      label={item.title}
      phone={item.phone}
      email={item.email}
      description={language === "ja" && item.description_ja}
    />
  ));

  return (
    <>
      <div className="hidden lg:flex flex-col lg:space-y-16">{cards}</div>
      <div className="lg:hidden mt-36">
        <SectionTitle>{t("homepage:Contact Us")}</SectionTitle>
        <Slider cardsToShow={1}>{cards}</Slider>
      </div>
    </>
  );
};

export default ContactUsContents;
